var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconForward = function SvgIconForward(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Icon Forward"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rechteck 494",
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Gruppe 1208",
    transform: "translate(1574 -13107)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 11",
    cx: 9,
    cy: 9,
    r: 9,
    transform: "translate(-1571 13110)",
    fill: "#0a1343"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2381",
    d: "M-1568 13123.833c1.806-2.528 4.333-3.683 7.944-3.683v2.961l5.056-5.056-5.056-5.055v2.889c-5.055.722-7.222 4.333-7.944 7.944Z",
    fill: "#fff"
  })))));
};
export default SvgIconForward;